var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigationArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "navigation-arrow-right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.172 12.0008L9.343 14.8288L10.757 16.2438L15 12.0008L10.757 7.75781L9.343 9.17281L12.172 12.0008Z",
    fill: "#758091"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationArrowRight);
export default __webpack_public_path__ + "static/media/navigation-arrow-right.13e04f4d908278c9526ba7526aa2e045.svg";
export { ForwardRef as ReactComponent };